import React from 'react';
import { ChevronRight, Newspaper, Zap, Globe, Bell } from 'lucide-react';

const NewsPage = () => {
  return (
    <div className="relative overflow-hidden bg-gradient-to-r from-blue-900 to-indigo-900">
      <div className="relative pt-16 pb-20 sm:pt-24 sm:pb-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl md:text-6xl">Coming soon...</h1>
            \n
            <h1 className="text-4xl font-bold mb-6 text-white">
              <span className="block">Stay Ahead in</span>
              <span className="block text-blue-400">Quantum Innovation</span>
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-lg text-gray-300">
              Your trusted source for quantum computing news, breakthroughs, and industry insights. From research developments to market trends, stay informed about the quantum revolution.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
              <button className="rounded-md bg-blue-500 px-6 py-3 text-white hover:bg-blue-600 flex items-center justify-center">
                Latest Updates
                <ChevronRight className="ml-2 h-4 w-4" />
              </button>
              <button className="rounded-md border border-white px-6 py-3 text-white hover:bg-white/10 flex items-center justify-center">
                Subscribe to Newsletter
                <Bell className="ml-2 h-4 w-4" />
              </button>
            </div>

            {/* Featured Categories */}
            <div className="mt-12 bg-white/10 rounded-lg p-6 max-w-3xl mx-auto backdrop-blur-sm">
              <h2 className="text-2xl font-semibold text-white mb-3">Featured Coverage</h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-gray-300">
                <div className="px-4 py-2 rounded-md hover:bg-white/10 cursor-pointer">
                  Research Breakthroughs
                </div>
                <div className="px-4 py-2 rounded-md hover:bg-white/10 cursor-pointer">
                  Industry Updates
                </div>
                <div className="px-4 py-2 rounded-md hover:bg-white/10 cursor-pointer">
                  Market Analysis
                </div>
                <div className="px-4 py-2 rounded-md hover:bg-white/10 cursor-pointer">
                  Tech Insights
                </div>
              </div>
            </div>

            {/* Key Features */}
            <div className="mt-16 grid grid-cols-1 gap-8 sm:grid-cols-3">
              <div className="flex flex-col items-center">
                <Zap className="h-12 w-12 text-blue-400" />
                <h3 className="mt-4 text-xl font-semibold text-white">Real-Time Updates</h3>
                <p className="mt-2 text-gray-300">Breaking news and instant alerts</p>
              </div>
              <div className="flex flex-col items-center">
                <Globe className="h-12 w-12 text-blue-400" />
                <h3 className="mt-4 text-xl font-semibold text-white">Global Coverage</h3>
                <p className="mt-2 text-gray-300">News from quantum hubs worldwide</p>
              </div>
              <div className="flex flex-col items-center">
                <Newspaper className="h-12 w-12 text-blue-400" />
                <h3 className="mt-4 text-xl font-semibold text-white">Expert Analysis</h3>
                <p className="mt-2 text-gray-300">In-depth insights and commentary</p>
              </div>
            </div>

            {/* Author/Contributor CTA */}
            <div className="mt-12 text-gray-300">
              <p className="text-sm">
                Have quantum news to share? <a href="#" className="text-blue-400 hover:text-blue-300">Become a contributor</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsPage;